import { useQueryClient } from "@tanstack/react-query";
import { useAppMutation } from "./useAppMutation";

export const useDeleteCourse = (id: string, onSuccess?: () => void) => {
    const queryClient = useQueryClient();
    return useAppMutation<unknown, Error, void>(
        'delete',
        `/Integration/Course/Delete/${id}`,
        {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['/TrainingManager/courses'] });
                onSuccess?.();
            },
        }
    );
};
